import { render, staticRenderFns } from "./GeolocationForm.vue?vue&type=template&id=5b5a2e6a&scoped=true&"
import script from "./GeolocationForm.vue?vue&type=script&lang=js&"
export * from "./GeolocationForm.vue?vue&type=script&lang=js&"
import style0 from "./GeolocationForm.vue?vue&type=style&index=0&id=5b5a2e6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a2e6a",
  null
  
)

export default component.exports